import React, {useState, useEffect,useMemo} from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import Style                                from "components/UI/main.module.scss";
import  {   //  Application Content
            getApplicationContentList,                   
        }                                   from "./contentScriptService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            sleep,
            IsMentor
        }                                   from "Utilities/utils";    
import { useModal }                         from "components/Covers/genericModal";
import {ModalContent}                       from "components/Modal/modal";
import {DisplayContent}                     from "components/ContentEditor/contentEditor"; 
import { AccessDeniedContent } from "components/Content/accessContent";

const AppContentContent             = React.memo(({ Current, Content, visible }) => {
    const isActive = Current === Content?.AppContentId;
    return (
        <div
            className={[
                Style.row,
                visible && isActive ? Style.text_animation_fadein : Style.text_animation_fadeout
            ].join(" ")}
            style={{ display: isActive ? "block" : "none" }}
        >
            <div className={Style.col}>
                <DisplayContent 
                    ContentClass={[Style.text_body].join(" ")}
                    Content={Content?.[`AppContentData${GetAppLang()}`]} 
                />
            </div>
        </div>
    ); 
});
const AppContentHeader              = React.memo(({...setProps}) => {
    const { Current, SetCurrent, Content }      = setProps;
    return (
        <React.Fragment>
            <div    className={[Style.clickable,
                                Style.py_3,
                                Style.mx_2,
                                Style.pop_item_animation].join(" ")}
                    onClick={() => SetCurrent(Content.AppContentId)}
            >
                <span   className={[
                                (Current === Content?.AppContentId) ? Style.text_body_active            : Style.text_body, 
                                (Current === Content?.AppContentId) ? Style.text_decoration_underline   : null, 
                                (Current === Content?.AppContentId) ? Style.fw_semibold                 : null,
                                (Current === Content?.AppContentId) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")
                        }
                >
                    {Content?.[`AppContentName${GetAppLang()}`]}
                </span>
            </div>
        </React.Fragment>
    );    
});
export const AppContentList         = React.memo(({...setProps}) => {
    const { ContentType, 
            ExternalDataSource
          }                                         = setProps;
    // Mount State                
    const [isReady, setIsReady]                     = useState(false);     
    // Loading State                  
    const [ isLoading,  setIsLoading]               = useState(true);  
    const [rowData,     setRowData]                 = useState([]);
    const [activeId,    setActiveId]                = useState(null);
    const [visible,     setVisible]                 = useState(false);
    const { showModal}                              = useModal();

    const [searchStatus, setSearchStatus]        = useState({StatusIds: [1]});    

    const handleMessageDisplay = async (id) => {
        // fade out
        setVisible(false);

        await sleep(300);

        // switch content
        setActiveId(id);

        // fade in
        setVisible(true);
    };

    const fetchAppContentList = async () => {
        setIsLoading(true);
        try {
            let payload = await getApplicationContentList(searchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                    if (payload.Response.Content.length > 0) {
                        handleMessageDisplay(payload.Response.Content[0].AppContentId);
                    }
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            if (ExternalDataSource) {
                setRowData(ExternalDataSource);
                setIsLoading(false);
                if (ExternalDataSource.length > 0) handleMessageDisplay(ExternalDataSource[0].AppContentId);
            }
            else {
                fetchAppContentList();
            }
        }
    }, [ContentType, isReady]);

    return (
        <React.Fragment>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <div className={[Style.d_flex, Style.align_self_baseline, Style.overflow_x_auto].join(" ")}>
                                {rowData?.map((d) => (
                                    <AppContentHeader 
                                        Current={activeId}
                                        SetCurrent={handleMessageDisplay}
                                        Content={d}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>                    
                    <div className={Style.py_1}/>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            {!activeId && (
                                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.mx_3].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8, Style.mx_3].join(" ")}>
                                        {GetBusinessLabel("ContentDisplayBlank")}
                                    </span>
                                    <svg    xmlns="http://www.w3.org/2000/svg" 
                                            viewBox="0 0 640 640"
                                            className={Style.fill_svg_theme}
                                            width="50"
                                            height="50"
                                    >
                                        <path d="M578.2 63.9C592.9 81.7 608 104 608 128C608 164.4 580.4 192 544 192C507.6 192 480 164.4 480 128C480 104 495.2 81.7 509.8 63.9C518.6 53.2 528.3 43.1 538.8 33.9C541.8 31.3 546.2 31.3 549.2 33.9C559.7 43 569.3 53.2 578.2 63.9zM320 64C362.5 64 402.6 74.4 437.8 92.7C434.2 103.6 432 115.4 432 128C432 190.9 481.1 240 544 240C550.4 240 556.7 239.5 562.8 238.5C571.4 264.1 576 291.5 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64zM450.7 372.9C411.5 385.1 367.1 392 320 392C272.9 392 228.5 385.1 189.3 372.9C177.4 369.2 165.4 379.2 169.7 391C192.1 452.3 251 496.1 320 496.1C389 496.1 447.9 452.3 470.3 391C474.6 379.2 462.6 369.2 450.7 372.9zM240 244C255.5 244 268 256.5 268 272L268 280C268 291 277 300 288 300C299 300 308 291 308 280L308 272C308 234.4 277.6 204 240 204C202.4 204 172 234.4 172 272L172 280C172 291 181 300 192 300C203 300 212 291 212 280L212 272C212 256.5 224.5 244 240 244zM372 272C372 256.5 384.5 244 400 244C415.5 244 428 256.5 428 272L428 280C428 291 437 300 448 300C459 300 468 291 468 280L468 272C468 234.4 437.6 204 400 204C362.4 204 332 234.4 332 272L332 280C332 291 341 300 352 300C363 300 372 291 372 280L372 272z"/>
                                    </svg>                                    
                                </div>
                            )}
                            {rowData?.map((d) => (
                                <AppContentContent 
                                    Current={activeId}
                                    Content={d}
                                    visible={visible}
                                />
                            ))}           
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
});

export const ContentScriptPage      = () => {
    const [ contentType,    setContentType          ]       = useState(1);
    const [ mount,          setMount                ]       = useState(false);   
    const { showLoader, hideLoader                  }       = useLoader();
    const [ access,         setAccess               ]       = useState(false);

    useEffect(() => {
        if(!mount) {
            if(IsMentor()) {
                setAccess(true);
                setMount(true);
            }
            setMount(true);
        }
    }, [contentType]);

    useEffect(() => {
    }, []);

    return (
        access ?
            <div className={[Style.m_2, Style.pb_5].join(" ")}>            
            {
                contentType === 1? 
                    <React.Fragment>
                        <AppContentList
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                        />
                    </React.Fragment>                               
                :
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};